import { asyncAction } from 'lib/actionCreators'

export const recruiterProfile = asyncAction('candidate/RECRUITER_PROFILE')
